import React from "react";
import style from "./index.module.scss";
import { Icon, Modal } from "antd";
import { ModalProps } from "antd/lib/modal";

interface LoadingMOdalProps extends ModalProps {
    onCancel: () => void;
}

export default function LoadingModal({
    onCancel,
    ...resProps
}: LoadingMOdalProps) {
    return (
        <Modal
            maskClosable
            width={416}
            title={null}
            footer={null}
            closable={false}
            className={style.root}
            onCancel={onCancel}
            {...resProps}>
            <Icon type="clock-circle" theme="filled" className={style.icon} />
            <div className={style.title}>导入试卷中...</div>
            <div className={style.tip}>
                若离开当前界面或退出系统，导入处理仍在继续，将任务完成后，您可在当前界面下载导入结果。
            </div>
        </Modal>
    );
}
